import { useEffect, useState } from "react";
import {} from "lucide-react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { GoldCoin } from "@/components/CoinIcons";

export function BountyWeekPanel() {
  const [ev, setEv] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/bounty-week").then((r) => setEv(r.data)).catch(() => setEv(null));
  useEffect(() => { load(); }, []);
  const toggle = async (action) => {
    setBusy(true);
    try { const r = await api.post("/admin/bounty-week", { action }); setEv(r.data); toast.success(action === "start" ? "Bounty Week started — runs 7 days!" : "Bounty Week ended — open bounties refunded."); }
    catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };
  const active = ev?.active;
  return (
    <div data-testid="bounty-week-panel" className="mb-6 border border-yellow-900/50 bg-gradient-to-br from-yellow-950/20 to-zinc-950 p-4 rounded-sm">
      <div className="flex items-center gap-2 mb-3">
        <GoldCoin size={16} className="text-yellow-400" />
        <h3 className="font-cinzel text-yellow-300 uppercase tracking-widest text-sm">Bounty Week Event</h3>
      </div>
      <div className="flex flex-wrap items-center gap-3">
        <p className="text-sm text-zinc-500 flex-1 min-w-[220px]">
          {active ? <span className="text-yellow-300">Active</span> : "Inactive"} — for 7 days, players post gold bounties on rival gladiators (gold escrowed up front). Defeat a bountied gladiator in a ranked fight to claim the pool. Unclaimed bounties refund when the event ends.
          {active && ev?.ends_at ? <span className="text-zinc-500"> Ends {new Date(ev.ends_at).toLocaleString()}.</span> : null}
        </p>
        {active ? (
          <button data-testid="bounty-week-stop" onClick={() => toggle("stop")} disabled={busy}
            className="px-5 py-2 border border-yellow-900/50 text-yellow-300 hover:border-yellow-500 font-cinzel uppercase tracking-wide text-sm rounded-sm disabled:opacity-50">End Bounty Week</button>
        ) : (
          <button data-testid="bounty-week-start" onClick={() => toggle("start")} disabled={busy}
            className="px-5 py-2 bg-yellow-600 text-zinc-950 font-cinzel uppercase tracking-wide text-sm hover:bg-yellow-500 rounded-sm disabled:opacity-50">Start Bounty Week</button>
        )}
      </div>
    </div>
  );
}
